import { render } from "./LinkUpdatedComponent.vue?vue&type=template&id=6032ef06&scoped=true"
import script from "./LinkUpdatedComponent.vue?vue&type=script&lang=js"
export * from "./LinkUpdatedComponent.vue?vue&type=script&lang=js"

import "./LinkUpdatedComponent.vue?vue&type=style&index=0&id=6032ef06&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6032ef06"]])

export default __exports__